import money from "assets/images/icons/money.png";
import { Menu } from "primereact/menu";
import { useRef } from "react";
import useCurrencyStore from "store/currencyStore";
import { activeCurrencies, getActiveCurrencyCodeLabel } from "utils";
import { IoIosArrowDown } from "react-icons/io";

const CurrencyConverter = () => {
	const { currency, setCurrency } = useCurrencyStore();

	const menu = useRef(null);

	const items = [
		{
			label: activeCurrencies.ZWL.label,
			command: () => {
				setCurrency(activeCurrencies.ZWL.code);
			},
		},
		{
			label: activeCurrencies.USD.label,
			command: () => {
				setCurrency(activeCurrencies.USD.code);
			},
		},
	];

	return (
		<>
			<button
				type="button"
				onClick={(event) => menu.current.toggle(event)}
				aria-controls="currency_menu"
				aria-haspopup
				className="flex items-center gap-2 px-2 xs:px-3 py-1.5 rounded-lg  transition-all duration-200 border border-gray-200 hover:border-akgreen/40 group min-w-max max-w-max"
			>
				<img
					src={money}
					alt="Currency Converter"
					width={20}
					className="opacity-80 hidden xl:block"
				/>
				<span className="font-cera-black text-sm text-akgreenest">
					{currency === "STARS" ? activeCurrencies.USD.label : getActiveCurrencyCodeLabel(currency)}
				</span>
				<span>
					<IoIosArrowDown
						size={16}
						className="text-akgreenest opacity-70 group-hover:opacity-100 transition-all duration-200"
					/>
				</span>
			</button>

			<Menu className="font-sans max-w-max" model={items} popup ref={menu} id="currency_menu" />
		</>
	);
};

export default CurrencyConverter;
